import { __ } from '@wordpress/i18n';
import type { BookingStatus } from '../typings/common/booking';

export const STATUS_LABELS: Record<BookingStatus, string> = {
	pending: __('Pending', 'gp-bookings'),
	confirmed: __('Confirmed', 'gp-bookings'),
	completed: __('Completed', 'gp-bookings'),
	cancelled: __('Cancelled', 'gp-bookings'),
	denied: __('Denied', 'gp-bookings'),
};

export function getStatusLabel(status: BookingStatus): string {
	return STATUS_LABELS[status] || status;
}

/**
 * Statuses a booking can still be moved from. Everything else is settled, one
 * way or the other, and stays put on the calendar.
 */
const RESCHEDULABLE_STATUSES: BookingStatus[] = ['pending', 'confirmed'];

/**
 * Whether a booking in this status may be dragged to a new slot.
 */
export function statusAllowsReschedule(status: BookingStatus): boolean {
	return RESCHEDULABLE_STATUSES.includes(status);
}

/**
 * Statuses that end a booking, and so are worth explaining to the customer.
 */
const REASON_STATUSES: BookingStatus[] = ['cancelled', 'denied'];

/**
 * Whether moving a booking to this status should offer a reason field.
 */
export function statusTakesReason(status: BookingStatus): boolean {
	return REASON_STATUSES.includes(status);
}

/**
 * Label for the reason field, phrased for the status being applied.
 *
 * Always optional: unlike the customer-facing management page, staff are never
 * blocked from ending a booking by the reason box.
 */
export function getReasonLabel(status: BookingStatus): string {
	return status === 'denied'
		? __('Reason for denying (optional)', 'gp-bookings')
		: __('Reason for cancelling (optional)', 'gp-bookings');
}
